/**
 * Normalize users from content-management kssParticipants response.
 * @param {Array<{ id?: string, _id?: string, name?: string, email?: string, picture_profile?: object | null }>} users
 * @returns {Array<{ id: string, name: string, email: string, label: string, searchText: string, picture_profile: object | null }>}
 */
export function normalizeParticipantUsers(users = []) {
  return users
    .map((user) => {
      const id = String(user.id || user._id || '').trim();
      if (!id) return null;

      const name = String(user.name || '').trim();
      const email = String(user.email || '').trim();
      const label = name || email || id;

      return {
        id,
        name,
        email,
        label,
        searchText: `${name} ${email}`.trim().toLowerCase(),
        picture_profile: user.picture_profile || null,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.label.localeCompare(b.label));
}

/**
 * @param {Array<{ id: string }>} users
 * @returns {Record<string, { id: string, name: string, email: string, label: string }>}
 */
export function buildUserLookup(users = []) {
  return users.reduce((lookup, user) => {
    lookup[user.id] = user;
    return lookup;
  }, {});
}

/**
 * @param {{ name?: string, email?: string, label?: string } | undefined} user
 * @returns {string}
 */
export function getUserDisplayName(user) {
  if (!user) return '';
  if (user.name) return user.name;
  if (user.email) return user.email;
  return user.label || '';
}

/**
 * @param {Array<{ searchText: string }>} users
 * @param {string} query
 * @returns {Array}
 */
export function filterUsersByQuery(users = [], query = '') {
  const normalizedQuery = String(query || '').trim().toLowerCase();
  if (!normalizedQuery) return users;
  return users.filter((user) => user.searchText.includes(normalizedQuery));
}
